import React from 'react';
import {store} from './store/store.js'
import {
  discardEdit,
  batchUpdateFields
} from './slices/dataSlice';
import { displayDirectors, displayPhones, displayEmails} from './Components/renderCellExpand'


const getLeadStatusStyle = (status) => {
  const match = leadStatusStyles.find((s) => (s.value??"").toUpperCase() === (status??"").toUpperCase());
  return match || { color: '#000', backgroundColor: '#eee' }; // fallback
};

//export const getLeadStatusStyle

const leadStatusStyles = [
  { value: 'NEW', color: '#ffffff', backgroundColor: '#007bff', conversion: 'NEW LEAD', label: 'New Lead'  },
  { value: 'IN PROGRESS', color: '#ffffff', backgroundColor: '#ffc107', conversion: 'IN PROGRESS', label: 'In Progress'  },
  { value: 'COMPLETED', color: '#ffffff', backgroundColor: '#28a745', conversion: 'SALE', label: 'Completed' },
  {value: 'QC_SALES', color: '#ffffff',backgroundColor: '#FFBF00', conversion: 'QC', label: 'QC Checking' },
  {value: 'QC_SALES_INFOEMAIL', color: '#ffffff',backgroundColor: 'red', conversion: 'QC',  label: 'QC Info Email Required'},
  {value: 'QC_FAILED', color: '#ffffff',backgroundColor: 'red', conversion: 'CLOSED',  label: 'QC Failed'},
  {value: 'INFOEMAIL', color: '#ffffff',backgroundColor: 'green', conversion: 'NEW LEAD',  label: 'Info Email Required'},
  {value: 'INFOEMAILLEAD', color: '#ffffff',backgroundColor: 'green', conversion: 'NEW LEAD',  label: 'Info Email - New Lead'},
  {value: 'LEAD_SALES',color: '#ffffff',  backgroundColor: 'orange', conversion: 'LEAD VERIFIED', label: 'Sales Lead' },
  {value: 'CONTACTED',color: '#ffffff',  backgroundColor: 'green', conversion: 'CUSTOMER VERIFIED', label: 'Contacted'  },
  {value: 'F2FMEETING',color: '#ffffff',  backgroundColor: 'green', conversion: 'CUSTOMER VERIFIED', label: 'In Person Meeting'  },
  {value: '1STCONTACT',color: '#ffffff',  backgroundColor: 'green',conversion: 'NO CONTACT',  label: '1st Contact Attempt' },
  {value: '2NDCONTACT',color: '#ffffff',  backgroundColor: 'yellow', conversion: 'NO CONTACT', label: '2nd Contact Attempt' },
  {value: '3RDCONTACT',color: '#ffffff',  backgroundColor: 'orange', conversion: 'NO CONTACT', label: '3rd Contact Attempt' },
  {value: '4THCONTACT',color: '#ffffff',  backgroundColor: 'red', conversion: 'NO CONTACT', label: '4th Contact Attempt' },
  {value: 'NO ANSWER',color: '#ffffff',  backgroundColor: 'orange', conversion: 'NO CONTACT', label: 'No Answer' },
  {value: 'ANSWERPHPONE',color: '#ffffff',  backgroundColor: 'orange', conversion: 'LEAD VERIFIED', label: 'Answer Phone'  },
  {value: 'CALLBACK BOOKED',color: '#ffffff',  backgroundColor: 'green', conversion: 'CUSTOMER VERIFIED', label: 'Callback Booked' },
  {value: 'CLOSED',color: '#ffffff',  backgroundColor: 'red', conversion: 'CLOSED', label: 'Lead Closed'  },
  { value: 'ARCHIVED', color: '#ffffff', backgroundColor: '#6c757d', conversion: 'SALE ARCHIVED', label: 'Sale Archived'  },
];

function dateFormatter(value) {
  if(typeof value === "undefined" || value == null || value === "")
    return "";
  var dt = "";
  try {
    dt = new Date(value).toISOString().replace("T"," ").substring(0,19)
  }catch(err) {
    dt = new Date().toISOString();
  }
  return dt;
}

export  const ttpcolumns = [
        {
          field: "id",
          headerName: "ID",
          width: 70,
          fldSection: 'hide'
        },
        {
          field: "uid",
          headerName: "Record Id",
          type: "number",
          functionname: "",
          fldType: "core",
          editable: false,
          hideable: true,
          visible: false,
          isphone: false,
          isemail: false,
          field_order: 1,
          fldSection: 'status'
        },
        {
          field: "date_created",
          headerName: "Date Created",
          type: "string",
          valueGetter: dateFormatter,
          functionname: "",
          fldType: "core",
          editable: false,
          hideable: true,
          visible: true,
          isphone: false,
          isemail: false,
          field_order: 54,
          fldSection: 'status',
          minWidth: 130,
          flex: 1, 
        },

        {
          field: "Lead Allocated Date",
          headerName: "Lead Allocated Date",
          type: "string",
          valueGetter: dateFormatter,
          functionname: "",
          fldType: "core",
          editable: false,
          hideable: true,
          visible: true,
          isphone: false,
          isemail: false,
          field_order: 4,
          fldSection: 'data'
        },
        {
          field: "lead_status",
          headerName: "Status",
          type: "singleselect",
          functionname: "",
          fldType: "core",
          editable: true,
          hideable: true,
          visible: true,
          isphone: false,
          isemail: false,
          field_order: 56,
          valueOptions: leadStatusStyles.map(item => ({
            value: item.value, 
            color: item.color, 
            backgroundColor:item.backgroundColor, 
            label: item.label }
          )),
          /*
          [
            { value: 'NEW', color: '#ffffff', label: 'New Lead' },
            {value: 'IN PROGRESS', color: '#ffffff', backgroundColor: '#28a745', label: 'Completed' },
            {value: 'QC_SALES', color: '#ffffff',backgroundColor: '#FFBF00', label: 'QC Checking'},
            {value: 'QC_SALES_INFOEMAIL', color: '#ffffff',backgroundColor: 'red',  label: 'QC Info Email Required'},
            {value: 'QC_FAILED', color: '#ffffff',backgroundColor: 'red',  label: 'QC Failed'},
            {value: 'INFOEMAIL', color: '#ffffff',backgroundColor: 'green',  label: 'Info Email Required'},
            {value: 'INFOEMAILLEAD', color: '#ffffff',backgroundColor: 'green', label: 'Info Email - New Lead'},
            {value: 'LEAD_SALES',color: '#ffffff',  backgroundColor: 'orange', label: 'Sales Lead' },
            {value: 'CONTACTED',color: '#ffffff',  backgroundColor: 'green', label: 'Contacted' },
            {value: 'F2FMEETING',color: '#ffffff',  backgroundColor: 'green', label: 'In Person Meeting'  },
            {value: '1STCONTACT',color: '#ffffff',  backgroundColor: 'green', label: '1st Contact Attempt' },
            {value: '2NDCONTACT',color: '#ffffff',  backgroundColor: 'yellow', label: '2nd Contact Attempt' },
            {value: '3RDCONTACT',color: '#ffffff',  backgroundColor: 'orange', label: '3rd Contact Attempt' },
            {value: '4THCONTACT',color: '#ffffff',  backgroundColor: 'red', label: '4th Contact Attempt' },
            {value: 'NO ANSWER',color: '#ffffff',  backgroundColor: 'orange', label: 'No Answer' },
            {value: 'ANSWERPHPONE',color: '#ffffff',  backgroundColor: 'orange', label: 'Answer Phone'  },
            {value: 'CALLBACK BOOKED',color: '#ffffff',  backgroundColor: 'green', label: 'Callback Booked' },
            {value: 'CLOSED',color: '#ffffff',  backgroundColor: 'green', label: 'Lead Closed' },
            {value: 'ARCHIVED', color: '#ffffff', backgroundColor: '#6c757d', label: 'Sale Archived'  },
          ],*/
          fldSection: 'status',
          minWidth: 190,
          flex: 1, 
          renderCell: (params) => {
            const { id, value, field } = params;

            const handleStatusChange = (event) => {
              store.dispatch(batchUpdateFields({ ids: [id], field, value: event.target.value??value }));
              store.dispatch(discardEdit(id));
            };

            const style = getLeadStatusStyle(params.value);
            return (
              <select value={params.value.toUpperCase()} onChange={handleStatusChange}
                style={{
                  padding: '1px 3px 1px 3px',
                  fontWeight: 'bold',
                  textAlign: 'center',
                  borderRadius:'4px',
                  fontSize: '8pt',
                  width: '160px',
                  ...style
                }}
                name={`status_${id}`}
                id={`status_${id}`}              >
                {leadStatusStyles.map((item) => (
                  <option key={`status_opt_${item.value}`} value={item.value}>{item.label}</option>
                ))}
              </select>
            );
          }
        },
        {
          field: "dialler_lead_id",
          headerName: "Dialier Id",
          type: "string",
          functionname: "",
          fldType: "core",
          editable: false,
          hideable: true,
          visible: true,
          isphone: false,
          isemail: false,
          field_order: 2,
          fldSection: 'data'
        },
        {
          field: "Lead Created By",
          headerName: "Lead Created By",
          type: "string",
          functionname: "",
          fldType: "core",
          editable: false,
          hideable: true,
          visible: true,
          isphone: false,
          isemail: false,
          field_order: 3,
          fldSection: 'data'
        },
        {
          field: "Lead Category",
          headerName: "Lead Category",
          type: "string",
          functionname: "",
          fldType: "core",
          editable: true,
          hideable: true,
          visible: true,
          isphone: false,
          isemail: false,
          field_order: 5,
          fldSection: 'data'
        },
        {
          field: "HotKey Sent To",
          headerName: "HotKey Sent To",
          type: "string",
          functionname: "",
          fldType: "core",
          editable: true,
          hideable: true,
          visible: true,
          isphone: false,
          isemail: false,
          field_order: 6,
          fldSection: 'data'
        },
        {
          field: "FullName",
          headerName: "Name",
          type: "string",
          functionname: "",
          fldType: "core",
          editable: true,
          hideable: false,
          visible: true,
          isphone: false,
          isemail: false,
          field_order: 12,
          fldSection: 'contact'
        },
        {
          field: "Title",
          headerName: "Title",
          type: "string",
          functionname: "",
          fldType: "core",
          editable: true,
          hideable: true,
          visible: true,
          isphone: false,
          isemail: false,
          field_order: 13,
          fldSection: 'contact'
        },
        {
          field: "FirstName",
          headerName: "FirstName",
          type: "string",
          functionname: "",
          fldType: "core",
          editable: true,
          hideable: true,
          visible: true,
          isphone: false,
          isemail: false,
          field_order: 14,
          fldSection: 'contact'
        },
        {
          field: "MiddleName",
          headerName: "MiddleName",
          type: "string",
          functionname: "",
          fldType: "core",
          editable: true,
          hideable: true,
          visible: true,
          isphone: false,
          isemail: false,
          field_order: 14,
          fldSection: 'contact'
        },

        {
          field: "LastName",
          headerName: "LastName",
          type: "string",
          functionname: "",
          fldType: "core",
          editable: true,
          hideable: true,
          visible: true,
          isphone: false,
          isemail: false,
          field_order: 15,
          fldSection: 'contact'
        },
        {
          field: "CompanyName",
          headerName: "Company",
          valueFormatter: (value) => {return (value??"").toUpperCase()},
          type: "string",
          functionname: "",
          fldType: "core",
          editable: true,
          hideable: false,
          visible: true,
          isphone: false,
          isemail: false,
          field_order: 16,
          fldSection: 'company',
          minWidth: 220
        },
        {
          field: "Company Number",
          headerName: "Company Number",
          type: "string",
          functionname: "",
          fldType: "core",
          editable: true,
          hideable: false,
          visible: true,
          isphone: false,
          isemail: false,
          field_order: 17,
          fldSection: 'company'
        },
        {
          field: "JobTitle",
          headerName: "JobTitle",
          type: "string",
          functionname: "",
          fldType: "core",
          editable: true,
          hideable: true,
          visible: true,
          isphone: false,
          isemail: false,
          field_order: 18,
          fldSection: 'contact'
        },
        {
          field: "Phone1",
          headerName: "CC Main Phone",
          type: "phone",
          functionname: "",
          fldType: "core",
          editable: true,
          hideable: true,
          visible: false,
          isphone: false,
          isemail: false,
          field_order: 19,
          fldSection: 'hide',
          note: 'Phone Dialed by Call Center'
        },
        {
          field: "Phone2",
          headerName: "CC Alt Phone",
          type: "phone",
          functionname: "",
          fldType: "core",
          editable: true,
          hideable: true,
          visible: false,
          isphone: false,
          isemail: false,
          field_order: 20,
          fldSection: 'hide',
          note: 'Alt Phone Collect from Call Center'
        },
        {
          field: "Mobile",
          headerName: "CC Mobile",
          type: "phone",
          functionname: "",
          fldType: "core",
          editable: true,
          hideable: true,
          visible: false,
          isphone: false,
          isemail: false,
          field_order: 21,
          fldSection: 'hide',
          note: 'Mobile Phone Collect from Call Center'
        },
        {
          field: "Additional Phone Numbers",
          headerName: "Additional Phone Numbers",
          type: "phone",
          fldType: "core",
          editable: true,
          hideable: true,
          visible: true,
          isphone: true,
          isemail: false,
          field_order: 22,
          fldSection: 'phone',
          renderCell: displayPhones(true),
        },
        {
          field: "Email",
          headerName: "Email",
          type: "email",
          functionname: "",
          //valueFormatter: (value) => {(value??"").toLowerCase()},
          renderCell: displayEmails(true),
          fldType: "core",
          editable: true,
          hideable: true,
          visible: true,
          isphone: false,
          isemail: true,
          field_order: 23,
          fldSection: 'contact'
        },
        {
          field: "campaign_id",
          headerName: "campaign_id",
          type: "string",
          functionname: "",
          fldType: "core",
          editable: true,
          hideable: true,
          visible: false,
          isphone: false,
          isemail: false,
          field_order: 7,
          fldSection: 'data'
        },
        {
          field: "script",
          headerName: "script",
          type: "string",
          functionname: "",
          fldType: "core",
          editable: true,
          hideable: true,
          visible: false,
          isphone: false,
          isemail: false,
          field_order: 8,
          fldSection: 'data'
        },
        {
          field: "listid",
          headerName: "listid",
          type: "string",
          functionname: "",
          fldType: "core",
          editable: true,
          hideable: true,
          visible: false,
          isphone: false,
          isemail: false,
          field_order: 9,
          fldSection: 'data'
        },
        {
          field: "Directors",
          headerName: "Directors",
          type: "function",
          functionname: "viewDirectors",
          fldType: "core",
          editable: true,
          hideable: true,
          visible: true,
          isphone: false,
          isemail: false,
          field_order: 10,
          fldSection: 'company',
          renderCell: displayDirectors(true)
        } ,
        {
          field: "Director Phones",
          headerName: "Director Phones",
          type: "hide",
          fldType: "core",
          editable: true,
          hideable: true,
          visible: true,
          isphone: false,
          isemail: false,
          field_order: 11,
          fldSection: 'hide'
        },
        {
          field: "Address",
          headerName: "Address",
          type: "string",
          functionname: "",
          fldType: "core",
          editable: true,
          hideable: true,
          visible: true,
          isphone: false,
          isemail: false,
          field_order: 24,
          fldSection: 'company'
        },
        {
          field: "Address2",
          headerName: "Address2",
          type: "string",
          functionname: "",
          fldType: "core",
          editable: true,
          hideable: true,
          visible: true,
          isphone: false,
          isemail: false,
          field_order: 25,
          fldSection: 'company'
        },
        {
          field: "Address3",
          headerName: "Address3",
          type: "string",
          functionname: "",
          fldType: "core",
          editable: true,
          hideable: true,
          visible: true,
          isphone: false,
          isemail: false,
          field_order: 26,
          fldSection: 'company'
        },
        {
          field: "TownCity",
          headerName: "TownCity",
          type: "string",
          functionname: "",
          fldType: "core",
          editable: true,
          hideable: true,
          visible: true,
          isphone: false,
          isemail: false,
          field_order: 27,
          fldSection: 'company'
        },
        {
          field: "Postcode",
          headerName: "Postcode",
          type: "string",
          functionname: "",
          fldType: "core",
          editable: true,
          hideable: true,
          visible: true,
          isphone: false,
          isemail: false,
          field_order: 28,
          fldSection: 'company'
        },
        {
          field: "Behind Terms HMRC",
          headerName: "Behind Terms HMRC",
          type: "string",
          functionname: "",
          fldType: "core",
          editable: true,
          hideable: true,
          visible: true,
          isphone: false,
          isemail: false,
          field_order: 29,
          fldSection: 'data'
        },
        {
          field: "Behind Out of Terms Suppliers",
          headerName: "Behind Out of Terms Suppliers",
          type: "string",
          functionname: "",
          fldType: "advisory",
          editable: true,
          hideable: true,
          visible: true,
          isphone: false,
          isemail: false,
          field_order: 30,
          fldSection: 'data'
        },
        {
          field: "Estimated Turnover Last Financial  Year",
          headerName: "Estimated Turnover Last Financial  Year",
          type: "string",
          functionname: "",
          fldType: "advisory",
          editable: true,
          hideable: true,
          visible: true,
          isphone: false,
          isemail: false,
          field_order: 31,
          fldSection: 'data'
        },
        {
          field: "Cash Flow Difficulties",
          headerName: "Cash Flow Difficulties",
          type: "string",
          functionname: "",
          fldType: "advisory",
          editable: true,
          hideable: true,
          visible: true,
          isphone: false,
          isemail: false,
          field_order: 32,
          fldSection: 'data'
        },
        {
          field: "Number of CCJs",
          headerName: "Number of CCJs",
          type: "number",
          functionname: "",
          fldType: "advisory",
          editable: true,
          hideable: true,
          visible: true,
          isphone: false,
          isemail: false,
          field_order: 33,
          fldSection: 'data'
        },
        {
          field: "Value of CCJs",
          headerName: "Value of CCJs",
          type: "number",
          functionname: "",
          fldType: "advisory",
          editable: true,
          hideable: true,
          visible: true,
          isphone: false,
          isemail: false,
          field_order: 34,
          fldSection: 'data'
        },
        {
          field: "Estimated Assets - RedFlag",
          headerName: "Estimated Assets - RedFlag",
          type: "number",
          functionname: "",
          fldType: "advisory",
          editable: true,
          hideable: true,
          visible: true,
          isphone: false,
          isemail: false,
          field_order: 35,
          fldSection: 'data'
        },
        {
          field: "Assets - IHT",
          headerName: "Assets - IHT",
          type: "number",
          functionname: "",
          fldType: "advisory",
          editable: true,
          hideable: true,
          visible: true,
          isphone: false,
          isemail: false,
          field_order: 36,
          fldSection: 'data'
        },
        {
          field: "Problems-S1-10",
          headerName: "Problems-S1-10",
          type: "number",
          functionname: "",
          fldType: "advisory",
          editable: true,
          hideable: true,
          visible: true,
          isphone: false,
          isemail: false,
          field_order: 37,
          fldSection: 'data'
        },
        {
          field: "Home Ownership",
          headerName: "Home Ownership",
          type: "string",
          functionname: "",
          fldType: "core",
          editable: true,
          hideable: true,
          visible: true,
          isphone: false,
          isemail: false,
          field_order: 38,
          fldSection: 'data'
        },
        {
          field: "TTP Debtors",
          headerName: "TTP Debtors",
          type: "string",
          functionname: "",
          fldType: "ttp",
          editable: true,
          hideable: true,
          visible: false,
          isphone: false,
          isemail: false,
          field_order: 39,
          fldSection: 'data'
        },
        {
          field: "Court Number",
          headerName: "Court Number",
          type: "string",
          functionname: "",
          fldType: "winders",
          editable: true,
          hideable: true,
          visible: false,
          isphone: false,
          isemail: false,
          field_order: 40,
          fldSection: 'data'
        },
        {
          field: "Full Petition Text",
          headerName: "Full Petition Text",
          type: "text",
          functionname: "",
          fldType: "winders",
          editable: true,
          hideable: true,
          visible: false,
          isphone: false,
          isemail: false,
          field_order: 41,
          fldSection: 'data'
        },
        {
          field: "Court",
          headerName: "Court",
          type: "string",
          functionname: "",
          fldType: "winders",
          editable: true,
          hideable: true,
          visible: false,
          isphone: false,
          isemail: false,
          field_order: 42,
          fldSection: 'data'
        },
        {
          field: "UAP Date",
          headerName: "UAP Date",
          type: "string",
          valueGetter: dateFormatter,
          functionname: "",
          fldType: "winders",
          editable: true,
          hideable: true,
          visible: false,
          isphone: false,
          isemail: false,
          field_order: 43,
          fldSection: 'data'
        },
        {
          field: "WUP Press Date",
          headerName: "WUP Press Date",
          type: "string",
          valueGetter: dateFormatter,
          functionname: "",
          fldType: "winders",
          editable: true,
          hideable: true,
          visible: false,
          isphone: false,
          isemail: false,
          field_order: 44,
          fldSection: 'data'
        },
        {
          field: "WUP Hearing Date",
          headerName: "WUP Hearing Date",
          type: "string",
          valueGetter: dateFormatter,
          functionname: "",
          fldType: "winders",
          editable: true,
          hideable: true,
          visible: false,
          isphone: false,
          isemail: false,
          field_order: 45,
          fldSection: 'data'
        },
        {
          field: "Adjourned Date",
          headerName: "Adjourned Date",
          type: "string",
          valueGetter: dateFormatter,
          functionname: "",
          fldType: "winders",
          editable: true,
          hideable: true,
          visible: false,
          isphone: false,
          isemail: false,
          field_order: 46,
          fldSection: 'data'
        },
        {
          field: "Petitioner",
          headerName: "Petitioner",
          type: "string",
          functionname: "",
          fldType: "winders",
          editable: true,
          hideable: true,
          visible: false,
          isphone: false,
          isemail: false,
          field_order: 47,
          fldSection: 'data'
        },
        {
          field: "email_optin",
          headerName: "Email Optin",
          type: "boolean",
          functionname: "",
          fldType: "core",
          editable: true,
          hideable: true,
          visible: true,
          isphone: false,
          isemail: false,
          field_order: 48,
          fldSection: 'contact'
        },
        {
          field: "email_optin_date",
          headerName: "Email Optin date",
          type: "string",
          valueGetter: dateFormatter,
          functionname: "",
          fldType: "core",
          editable: true,
          hideable: true,
          visible: true,
          isphone: false,
          isemail: false,
          field_order: 49,
          fldSection: 'contact'
        },
        {
          field: "phone_optin",
          headerName: "Phone Optin",
          type: "boolean",
          functionname: "",
          fldType: "core",
          editable: true,
          hideable: true,
          visible: true,
          isphone: false,
          isemail: false,
          field_order: 50,
          fldSection: 'contact'
        },
        {
          field: "phone_optin_date",
          headerName: "Phone Optin date",
          type: "string",
          valueGetter: dateFormatter,
          functionname: "",
          fldType: "core",
          editable: true,
          hideable: true,
          visible: true,
          isphone: false,
          isemail: false,
          field_order: 51,
          fldSection: 'contact'
        },
        {
          field: "sms_optin",
          headerName: "SMS Optin",
          type: "boolean",
          functionname: "",
          fldType: "core",
          editable: true,
          hideable: true,
          visible: true,
          isphone: false,
          isemail: false,
          field_order: 52,
          fldSection: 'contact'
        },
        {
          field: "sms_optin_date",
          headerName: "SMS Optin date",
          type: "string",
          valueGetter: dateFormatter,
          functionname: "",
          fldType: "core",
          editable: true,
          hideable: true,
          visible: true,
          isphone: false,
          isemail: false,
          field_order: 53,
          fldSection: 'contact'
        },
        {
          field: "date_updated",
          headerName: "Date Updated",
          type: "string",
          valueGetter: dateFormatter,
          functionname: "",
          fldType: "core",
          editable: false,
          hideable: true,
          visible: true,
          isphone: false,
          isemail: false,
          field_order: 55,
          fldSection: 'status'
        },
        {
          field: "lead_allocated_to",
          headerName: "Allocated To",
          type: "string",
          functionname: "",
          fldType: "core",
          editable: false,
          hideable: true,
          visible: true,
          isphone: false,
          isemail: false,
          field_order: 56,
          fldSection: 'status'
        },

]

export const ttpVisibilityModel = {
    // Hide columns status and traderName, the other columns will remain visible
    excelrow: false,
    uid: false,
    Phone1: false,
    Phone2: false,
    Mobile: false,
    'Director Phones': false,
    "dialler_lead_id": false,
    FullName: false,
    "Lead Allocated Date": false,
    'TTP Debtors':false,
    'Court Number':false,
    'Full Petition Text':false,
    Court:false,
    'UAP Date':false,
    'WUP Press Date':false,
    'WUP Hearing Date':false,
    'Adjourned Date':false,
    'Petitioner':false
}
export const calloutcomes =[
  {value:"", label: "Select A Call Outcome"},
  {value: "NOANS",label: "No Answer"},
  {value: "ANSPHONE",label: "Answer Phone"},
  {value: "ENGAGED",label: "Engaged"},
  {value: "NNR",label: "Number Not Recognised"},
  {value: "DEADNUM",label: "Dead Number"},
  {value: "DNC",label: "DO NOT CONTACT"},
  {value: "OVERSEAS",label: "Overseas"},
  {value: "CLBCK",label: "Call Back"},
  {value: "COMPLETE",label: "Call Completed"}
]

export const ttpsizeOptions={
    columns: ['CompanyName', 'Company Number','lead_status','date_created','Title','FirstName','LastName'],
    includeOutliers: true,
    includeHeaders: false,
}



//export const statuses =leadStatusStyles;